import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const comportamentoRepository = RepositoryFactory.get('comportamento');

const state = {
  comportamentosGosto: [],
  comportamentosNaoGosto: [],
  comportamentosIdeal: [],
  comportamentosComissao: [],
  comportamentosConsolidados: [],
  loaded: {
    mapeamento: null,
    status: false,
  },
};

const actions = {
  load({ commit }, payload) {
    return new Promise((resolve) => {
      comportamentoRepository.getAll(payload.mapeamento, payload.comissao).then((res) => {
        const comportamentos = res.data;

        if (payload.comissao) {
          commit('SET_COMPORTAMENTOS_COMISSAO', comportamentos);
        } else {
          commit('SET_COMPORTAMENTOS_GOSTO', comportamentos.filter((c) => c.categoria === 'GOSTO'));
          commit('SET_COMPORTAMENTOS_NAO_GOSTO', comportamentos.filter((c) => c.categoria === 'NAO_GOSTO'));
          commit('SET_COMPORTAMENTOS_IDEAL', comportamentos.filter((c) => c.categoria === 'IDEAL'));
        }
        resolve();
      });
    });
  },
  setComportamentos({ commit }, payload) {
    return new Promise((resolve) => {
      switch (payload.tipo) {
        case 'GOSTO':
          commit('SET_COMPORTAMENTOS_GOSTO', payload.comportamentos);
          break;
        case 'NAO_GOSTO':
          commit('SET_COMPORTAMENTOS_NAO_GOSTO', payload.comportamentos);
          break;
        case 'IDEAL':
          commit('SET_COMPORTAMENTOS_IDEAL', payload.comportamentos);
          break;
        case 'COMISSAO':
          commit('SET_COMPORTAMENTOS_COMISSAO', payload.comportamentos);
          break;
        default:
          break;
      }
      resolve();
    });
  },
  setLoaded({ commit }, loaded) {
    commit('SET_LOADED', loaded);
  },
};

const getters = {
  isCadastroIniciado(st) {
    return st.comportamentosGosto.length > 0 || st.comportamentosNaoGosto.length > 0
      || st.comportamentosIdeal.length > 0;
  },
  isCadastroFinalizado(st) {
    return st.comportamentosGosto.length > 0 && st.comportamentosNaoGosto.length > 0
      && st.comportamentosIdeal.length > 0;
  },
  getTotalComportamentosGosto(st) {
    return st.comportamentosGosto.length;
  },
  getTotalComportamentosNaoGosto(st) {
    return st.comportamentosNaoGosto.length;
  },
  getTotalComportamentosIdeal(st) {
    return st.comportamentosIdeal.length;
  },
};

const mutations = {
  SET_COMPORTAMENTOS_GOSTO: (st, comportamentos) => {
    st.comportamentosGosto = comportamentos;
  },
  SET_COMPORTAMENTOS_NAO_GOSTO: (st, comportamentos) => {
    st.comportamentosNaoGosto = comportamentos;
  },
  SET_COMPORTAMENTOS_IDEAL: (st, comportamentos) => {
    st.comportamentosIdeal = comportamentos;
  },
  SET_COMPORTAMENTOS_COMISSAO: (st, comportamentos) => {
    st.comportamentosComissao = comportamentos;
  },
  SET_COMPORTAMENTOS_CONSOLIDADOS: (st, comportamentos) => {
    st.comportamentosConsolidados = comportamentos;
  },
  SET_LOADED: (st, loaded) => {
    st.loaded = loaded;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
